import { render, staticRenderFns } from "./ValidityTable.vue?vue&type=template&id=5183dc5c&"
import script from "./ValidityTable.vue?vue&type=script&lang=js&"
export * from "./ValidityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports